import React from 'react';
import { Outlet } from 'react-router-dom';

import StyledLayout from './MainLayout.styled';

const MainLayout = () => {
  return (
    <StyledLayout>
      <Outlet />
    </StyledLayout>
  );
};

export default MainLayout;
